import { Component, OnInit } from '@angular/core';
import { SecurityPermissionName } from '@app/core/models/permission';

@Component({
  selector: 'portal-service-provider-main-nav',
  templateUrl: './service-provider-main-nav.component.html',
  styles: [],
  standalone: false,
})
export class ServiceProviderMainNavComponent implements OnInit {
  Permission = SecurityPermissionName;

  constructor() {}

  ngOnInit() {}

  protected readonly SecurityPermissionName = SecurityPermissionName;
}
